import axios from '../axiosConfig';

export default {
  getInvoicesList: (paramsPayload) => axios.get('/api/ocot/invoices', {
    params: paramsPayload
  }).then(response => response.data),

  getAdminRequestedInvoicesList: (paramsPayload) => axios.get('/api/ocot/adminRequestedInvoices', {
    params: paramsPayload
  }).then(response => response.data),

  getInvoicesListFromProvider: (paramsPayload) => axios.get('/api/ocot/invoicesFromProvider', {
    params: paramsPayload
  }).then(response => response.data),

  getNotificationsList: (paramsPayload) => axios.get('/api/ocot/getNotifications', {
    params: paramsPayload
  }).then(response => response.data),

  setNotificationRead: (paramsPayload) => axios.get('/api/ocot/setNotificationRead', {
    params: paramsPayload
  }).then(response => response.data),

  getReceiptDocument: (paramsPayload) => axios.get('/api/ocot/getReceiptDocument', {
    params: paramsPayload,
    responseType: 'blob',
        headers: {
          Accept: 'application/pdf'
        }
  }).then(response => response.data),
};
